export default __webpack_public_path__ + "static/media/theo.1a4943be.webp";